import { Component, OnInit, NgZone } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-stores',
  templateUrl: './stores.page.html',
  styleUrls: ['./stores.page.scss'],
})
export class StoresPage implements OnInit {
  lattitude: any = ''
  longitude: any = ''
  canScrollToLoadMore:any = false
  paginationData:any= ''
  featured: any = []
  constructor(public zone: NgZone,private api :ApiService,private router: Router) { 

  }

  ngOnInit() {
    this.lattitude = this.api.myLatitude.getValue()
    this.longitude = this.api.myLongitde.getValue()
    if(this.lattitude == ''  || this.lattitude == undefined || this.lattitude == null){
      this.lattitude = localStorage.getItem('latitude')
      this.longitude = localStorage.getItem('longitude')
    }
    this.api.getAllStoresNearbyWthPagnation(this.lattitude, this.longitude).subscribe((result:any) => {
      if(result.status == true){
          if(result.data.length > 0){
              this.featured = result.data;
              this.paginationData = result.links
              if(result.links.next != null){
                this.canScrollToLoadMore = true
              }
              else{
                this.canScrollToLoadMore = false
              }
          }
          else{
            if(result.links.next != null){
              this.canScrollToLoadMore = true
            }
            else{
              this.canScrollToLoadMore = false
            }
          }
        }
      },(err)=>{
        console.log(err)
      })
    }

    doInfinite(event:any){
      this.zone.run(() => {
        try {
          this.api.getProductsListWithPagination(this.paginationData.next).subscribe((result:any) => {
            if(result.status == true){
              if(result.data.length > 0){
                let temp:any = result.data
                for(let i = 0; i < temp.length; i++){
                  this.featured.push(temp[i])
                }
                this.paginationData = result.links
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
            }
            event.target.complete();
          },(err)=>{
            event.target.complete();
            console.log(err)
          });
        }
        catch (error) {
          event.target.complete();
          console.error('Here is the error message', error);
        }
      })
    }

    goToStorePage(store: any){
      localStorage.setItem('subscriber_id',store.subscriber)
      localStorage.setItem('store-name',store.store_name)
      localStorage.setItem('store-info',JSON.stringify(store))
      this.router.navigate(['/home/'+store.id])
    }

}
